/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desired_It_SkillsInputs */

const de_desired_it_skills = /** @type {(inputs: Desired_It_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IT-Kenntnisse (wünschenswert)`)
};

/** @type {(inputs: Desired_It_SkillsInputs) => LocalizedString} */
const en_desired_it_skills = () => /** @type {LocalizedString} */ ('desired_it_skills')

/**

* @param {Desired_It_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const desired_it_skills = /** @type {((inputs?: Desired_It_SkillsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desired_It_SkillsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_desired_it_skills(inputs)
	return en_desired_it_skills(inputs)
});